import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { getClientTimezone } from '@core/helpers';
import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse, ChartData } from './referrals.entity';

@Injectable({
  providedIn: 'root'
})
export class ReferralsService extends AbstractService {
  protected override prefix = '/users/referrals';

  getStatus(): Observable<ApiResponse.UserStatus> {
    return this.get<ApiResponse.UserStatus>('/status');
  }

  getCreatedPromocodes(): Observable<ApiResponse.CreatedPromocodes> {
    return this.get<ApiResponse.CreatedPromocodes>('/promocodes');
  }

  createPromocode(promocodeName: string, promocodeUses: number): Observable<void> {
    return this.post<void>('/promocodes', { promocodeName, promocodeUses }, { throwError: true });
  }

  getUserCampaigns(): Observable<ApiResponse.UserCampaigns> {
    return this.get<ApiResponse.UserCampaigns>('/campaigns');
  }

  getCampaign(id: number): Observable<ApiResponse.UserCampaign> {
    return this.get<ApiResponse.UserCampaign>(`/campaigns/${ id }`);
  }

  updateCampaign(id: number, name: string): Observable<void> {
    return this.patch<void>(`/campaigns/${ id }`, { name }, { throwError: true });
  }

  createUserCampaign(name: string, code: string): Observable<ApiResponse.CreatedUserCampaign> {
    return this.post<ApiResponse.CreatedUserCampaign>('/campaigns', { name, code }, { throwError: true });
  }

  tetherToCode(code: string, throwError: boolean): Observable<ApiResponse.TetherToCode> {
    return this.post<ApiResponse.TetherToCode>('/tether-to-code', { code }, { throwError });
  }

  getFinanceChart(intervalDays: number, campaignId?: number): Observable<ChartData> {
    return this.get<ChartData>('/charts/finance', {
      intervalDays,
      campaignId,
      clientTimezone: getClientTimezone()
    });
  }

  getRegistrationsChart(intervalDays: number, campaignId?: number): Observable<ChartData> {
    return this.get<ChartData>('/charts/registrations', {
      intervalDays,
      campaignId,
      clientTimezone: getClientTimezone()
    });
  }

  getTransactions(page: number, campaignId?: number): Observable<ApiResponse.TransactionList> {
    return this.get<ApiResponse.TransactionList>('/transactions', { page, campaignId });
  }
}